import __base_store from '@/store/__base_store'

/**
 * Store de modos de compra de Mercado Libre (modelo `meli_buying_mode`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'meli_buying_mode',
	},
})

